/**
 * Month index (0–11) to land on after picking a year in the Calendar year grid.
 * `react-day-picker`'s `selected` is a Date in single mode and a DateRange in
 * range mode — calling `.getMonth()` on a range throws and leaves the UI stuck.
 */
export function selectedMonthIndex(selected: unknown): number {
  if (selected instanceof Date) return selected.getMonth();
  if (selected && typeof selected === 'object' && 'from' in selected) {
    const { from } = selected as { from?: unknown };
    if (from instanceof Date) return from.getMonth();
  }
  return 0;
}
